// @flow
import React from 'react';
import type { ChildrenArray, Element } from 'react';
import {
  types as t,
  usePropsValidation,
} from '../validation/runtime-checks/index.js';
import { SolidifyWorkedExample } from './SolidifyWorkedExample.js';
import {
  STNCommonMisconceptions,
  STNEnglishLearnerSupport,
  STNInstructionalSupportDisability,
  STNInstructionalSupportInformation,
} from './STNInstructionalSupport.js';
import { productColor } from '../designSystem.js';

export function STNAdditionalExamples(props: {|
  children: ChildrenArray<Element<typeof STNAdditionalExample>>,
|}) {
  const { failedValidation } = usePropsValidation(props, STNAdditionalExamples);
  if (failedValidation) return null;

  return (
    <div style={{ color: productColor.shuttleGrey }}>
      <h1
        style={{
          fontFamily: 'Proxima Nova',
          fontStyle: 'normal',
          color: productColor.cloudburst,
          fontWeight: 600,
          fontSize: 18,
          lineHeight: '24px',
          marginTop: 34,
          marginBottom: 18,
          marginLeft: 30,
        }}
      >
        Teacher-led examples
      </h1>
      {React.Children.map(props.children, (child, index) =>
        React.cloneElement(child, { _index: index }),
      )}
    </div>
  );
}

STNAdditionalExamples.spec = {
  children: t.children(t.minimumCount(1, t.elementType(STNAdditionalExample))),
};

/**
 * This component only serves as a validation layer. We don't do anything else here
 */
export function STNAdditionalExample(props: { children: any, _index: number }) {
  const { failedValidation } = usePropsValidation(props, STNAdditionalExample);
  if (failedValidation) return null;
  const workedExample = React.cloneElement(
    React.Children.toArray(props.children)[0],
    {
      _index: props._index,
    },
  );
  const rest = React.Children.toArray(props.children).slice(1);
  return (
    <>
      {workedExample}
      <div style={{ height: 40 }} />
      <div style={{ marginLeft: 30 }}>{rest}</div>
    </>
  );
}

STNAdditionalExample.spec = {
  children: t.prefixChildrenArray(
    t.elementType(SolidifyWorkedExample),
    t.minimumCount(
      0,
      t.unionOfTypes(
        t.elementType(STNInstructionalSupportDisability),
        t.elementType(STNInstructionalSupportInformation),
        t.elementType(STNEnglishLearnerSupport),
        t.elementType(STNCommonMisconceptions),
      ),
    ),
  ),
};
